import { Box, Flex, FlexProps, List, Text } from '@chakra-ui/react';
import { useCombobox } from 'downshift';
import { FC } from 'react';

import { ComboboxInput } from '@/components/ui/shared/combobox/components/ComboboxInput/ComboboxInput';
import { ComboboxItem } from '@/components/ui/shared/combobox/components/ComboboxItem/ComboboxItem';

interface ICombobox extends FlexProps {
  itemsList: Array<string>;
  placeholder: string;
  selectedOption: string;

  onChangeItem(item: string): void;
  onSearchChange(inputValue: string): void;
}

export const Combobox: FC<ICombobox> = ({
  selectedOption,
  onChangeItem,
  onSearchChange,
  placeholder,
  itemsList,
  ...rest
}) => {
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    selectedItem,
    setInputValue,
    getItemProps,
  } = useCombobox({
    items: itemsList,
    onInputValueChange: ({ inputValue }) => {
      onSearchChange(inputValue);
    },
    onSelectedItemChange: ({ inputValue }) => {
      setInputValue('');
      onChangeItem(inputValue);
    },
  });

  return (
    <Flex direction="column" align="center" pos="relative" {...rest}>
      <Text
        as="button"
        fontWeight={600}
        color="violet.400"
        {...getToggleButtonProps()}
        noOfLines={1}
        minW="100%"
        pl={2}
      >
        {selectedItem ?? selectedOption}
      </Text>
      <Box w="100%" display={isOpen ? null : 'none'}>
        <Flex
          pos="absolute"
          overflow="auto"
          zIndex="dropdown"
          direction="column"
          flex="1 1 auto"
          bg="white"
          w="100%"
          minW="280px"
          mt={3}
          boxShadow="lg"
          borderRadius="sm"
          color="black"
        >
          <Flex direction="row" alignItems="baseline">
            <ComboboxInput {...getInputProps()} placeholder={placeholder} />
          </Flex>
          <List {...getMenuProps()} flex={1} overflowY="auto" mt={2} maxH="280px">
            {itemsList.map((item, index) => (
              <ComboboxItem
                {...getItemProps({ item, index })}
                key={`${index}_${item}`}
                bg={index === highlightedIndex ? 'gray.50' : null}
                item={item}
                isSelected={item === selectedItem || item === selectedOption}
              />
            ))}
          </List>
        </Flex>
      </Box>
    </Flex>
  );
};
